// NOTICE: KAPTION-INTEGRATION
// API client for fetching Kaption utility templates
/* global axios */
import ApiClient from './ApiClient';

class KaptionUtilityTemplates extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  /**
   * Get utility templates for an inbox
   * @param {number} inboxId - The inbox ID
   * @param {string} [type] - Optional filter by template type (followup, scheduled, reminder)
   * @returns {Promise} API response with templates data
   */
  getTemplates(inboxId, type = null) {
    const params = type ? { type } : {};
    // Use global axios, not this.axios (ApiClient uses global axios)
    return axios.get(`${this.url}/${inboxId}/kaption_utility_templates`, {
      params,
    });
  }
}

export default new KaptionUtilityTemplates();
